<script>
export default {
  name: "newBoldCloseIcon",
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M1.51676 15.9926C1.12369 16.0159 0.737224 15.8837 0.44076 15.6246C0.158212 15.3357 0 14.9477 0 14.5436C0 14.1395 0.158212 13.7515 0.44076 13.4626L13.3078 0.446607C13.4521 0.308784 13.6226 0.201162 13.8091 0.130048C13.9956 0.0589339 14.1944 0.0257574 14.3939 0.0324629C14.5934 0.0391684 14.7895 0.0856211 14.9708 0.169099C15.1521 0.252576 15.315 0.3714 15.4498 0.518607C15.7 0.790387 15.8447 1.14275 15.8578 1.51197C15.8708 1.88119 15.7512 2.24287 15.5208 2.53161L2.57776 15.6246C2.28509 15.88 1.90474 16.012 1.51676 15.9926Z"
      fill="#7A889B"
    />
    <path
      d="M14.3687 15.9936C13.9701 15.9914 13.5886 15.8314 13.3077 15.5486L0.441691 2.5316C0.180082 2.22163 0.0507686 1.82126 0.0816345 1.41682C0.1125 1.01239 0.301073 0.636281 0.606691 0.3696C0.879895 0.131296 1.23016 0 1.59269 0C1.95522 0 2.30549 0.131296 2.57869 0.3696L15.5207 13.3866C15.8144 13.6663 15.9865 14.0502 15.9997 14.4556C16.013 14.8609 15.8665 15.2553 15.5917 15.5536C15.569 15.5783 15.5454 15.6019 15.5207 15.6246C15.3647 15.7625 15.1818 15.8665 14.9834 15.9298C14.7851 15.9932 14.5757 16.0146 14.3687 15.9926V15.9936Z"
      fill="#7A889B"
    />
  </svg>
</template>

<style scoped></style>
